module.exports = __webpack_public_path__ + "static/media/test1 (16).323600e2.jpg";